import en from './locales/en/index';
import uk from './locales/uk/index';

export const messages = {
  en,
  uk,
};
